import React, { useRef } from 'react'
import Header from '../Header/Header.js';
import SideBar from './SideBar.js';
import { FaCheckCircle, FaExclamationTriangle, FaTruckLoading } from "react-icons/fa";
import { FaBoxesStacked, FaMoneyBillWave } from 'react-icons/fa6';
import { BsInboxesFill } from 'react-icons/bs';
import { RiWeightFill } from 'react-icons/ri';
import Table from "../components/Table/index.jsx";
import { MdOutlineVisibility } from 'react-icons/md';
import { Link } from 'react-router-dom';

const issues = [
    { title: "Shipments Related Issues", icon: <FaBoxesStacked size={170} className="text-slate-100" />, link: "/shipmentrelated" },
    { title: "Pickups Related Issues", icon: <FaTruckLoading size={170} className="text-slate-100" />, link: "/shipmentrelated" },
    { title: "Billing & Remittance", icon: <FaMoneyBillWave size={170} className="text-slate-100" />, link: "/techrelated" },
    { title: "Weight Related Issues", icon: <RiWeightFill size={170} className="text-slate-100" />, link: "/techrelated" },
    { title: "Tech Related Issues", icon: <BsInboxesFill size={170} className="text-slate-100" />, link: "/techrelated" },
];

const Escalations = () => {

    return (
        <div>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <div className="flex mb-6 px-6 md:px-0 flex-col md:flex-row justify-between items-start md:items-center">
                        <div>
                            <h3 className="text-2xl font-bold  text-gray-900">Having an issue?</h3>
                            <p className="text-lg text-gray-500 mb-4 md:mb-0">Select the escalation type below</p>
                        </div>

                        <Link to='/viewtableescalation'> <p className="mt-4 px-16 cursor-pointer py-2 rounded-lg text-white font-medium transition-all 
  bg-gradient-to-r from-slate-600 to-slate-700 hover:from-slate-700 hover:to-slate-600 
  shadow-lg hover:shadow-xl dark:from-gray-700 dark:to-gray-800 dark:hover:from-gray-800 dark:hover:to-gray-700">
                            View Escalations
                        </p></Link>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-6">
                        {issues?.map((issue, index) => (
                            <Link to={issue?.link}
                                key={index}
                                state={{ selectedIssue: issue?.title }}
                                className="p-6 h-96 border rounded-lg shadow-md bg-white transition-all hover:shadow-lg flex flex-col justify-between"
                            >
                                <h4 className="text-lg font-semibold text-gray-800">
                                    {issue.title}
                                </h4>
                                {issue.icon}
                                <div>
                                    <p className="text-gray-600 text-sm">
                                        If you're facing issues with {issue.title.toLowerCase()}, escalate now for quick resolution.
                                    </p>

                                    <button className="mt-4 w-full py-2 rounded-lg text-white font-medium transition-all 
  bg-gradient-to-r from-slate-600 to-slate-700 hover:from-slate-700 hover:to-slate-600 
  shadow-lg hover:shadow-xl dark:from-gray-700 dark:to-gray-800 dark:hover:from-gray-800 dark:hover:to-gray-700">
                                        Escalate here
                                    </button>


                                </div>
                            </Link>
                        ))}

                    </div>
                    <div className="w-full bg-white shadow-md rounded-lg p-4 mt-7 md:p-6 flex items-center justify-center text-gray-700">
                        {/* Support Text */}
                        <p className="text-sm font-medium text-center">
                            For Urgent Support Connect us at{" "}
                            <span className="font-semibold text-black">(+91) 022 6962 2461 (Mumbai)</span> | Email:{" "}
                            <a
                                href="mailto:wallet.support@xpressbees.com"
                                className="text-blue-500 hover:underline"
                            >
                                uk@uk-logistic.com
                            </a>
                        </p>
                    </div>

                </div>
            </div>

        </div >
    )
}

export default Escalations
